import { TrackingEvent } from 'client/tracking/event';
import { CommonMap } from 'client/tracking/maps/common';
import { SuggestedVehiclePricingCarouselMap } from 'site-modules/shared/components/suggested-vehicle-pricing-carousel/tracking';
import { TrackingConstant } from 'client/tracking/constant';

const map = {
  click_view_dealer_page: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_DEALER_ENGAGEMENT,
    TrackingConstant.VIEW_DEALER_DETAILS
  ),
  click_write_dealer_review: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_WRITE_REVIEW,
    TrackingConstant.GO_TO_DEALER_REVIEW_FORM
  ),
  click_search_dealer_btn: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_MMY_SELECT,
    TrackingConstant.SUBMIT_DEALER
  ),
  ddp_call_dealer() {
    return TrackingEvent.actionCompleted(TrackingConstant.ACTION_DEALER_ENGAGEMENT, TrackingConstant.CALL_DEALER);
  },
};

export const TrackingMap = {
  ...CommonMap,
  ...SuggestedVehiclePricingCarouselMap,
  ...map,
};
